import { ArrowLeft } from 'lucide-react'
import { useNavigate } from 'router-v6'
import { cn } from '../lib/utils'
import { Button } from './button'

interface BackButtonProps {
  className?: string
  'data-testid'?: string
}

export const BackButton = ({ className, 'data-testid': testId }: BackButtonProps) => {
  const navigate = useNavigate()

  const handleBack = () => {
    navigate(-1)
  }

  return (
    <Button
      variant="ghost"
      size="icon"
      className={cn('h-6 w-6', className)}
      onClick={handleBack}
      data-testid={testId ?? 'back-btn'}
    >
      <ArrowLeft className="h-4 w-4" />
    </Button>
  )
}
